import type { UploadMeasurementsResponse } from '@weft/api-definition';
import { UploadMeasurementsResponseSchema } from '@weft/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useUploadMeasurements(options?: UseMutationOptions<UploadMeasurementsResponse, unknown, { customerNames: string[], file: File }>) {
  return useMutation(
    async ({ customerNames, file }) => {
      const api = getPrivateApi();
      
      const formData = new FormData();
      formData.append('file', file);
      formData.append('customerNames', JSON.stringify(customerNames));

      const uploadMeasurementsResponse = await api.uploadMeasurements({ body: formData });

      return UploadMeasurementsResponseSchema.parse(uploadMeasurementsResponse);
    },
    options,
  );
}